import { fetchWithAuth } from "../utils/fetchWithAuth";

const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:8080";

export async function getRestaurantBySlug(slug) {
    const url = new URL(`/api/restaurants/${encodeURIComponent(slug)}`, BASE_URL);
    const res = await fetchWithAuth(url.toString());

    if (res.status === 404) return null;
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    return await res.json(); // { id, name, slug, address }
}
